import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import { templateList, typeList, controllist, templateStatus, delTemplate } from './request';
import templateModel from './templateModel.vue';
let expandedRowKeys = [];
const rowSelection = {
  onSelect: (record, selected, selectedRows) => {
    console.log(record, selected, selectedRows);
    expandedRowKeys = selectedRows;
  },
  onSelectAll: (selected, selectedRows, changeRows) => {
    expandedRowKeys = selectedRows;
  }
};
export default {
  components: {
    templateModel
  },
  data() {
    return {
      form: {
        name: '',
        type: undefined
      },
      templateShow: false,
      expandedRowKeys,
      rowSelection,
      typeList: typeList,
      controlList: controllist,
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      },
      data: [],
      columns: [{
        slots: {
          title: '类型'
        },
        dataIndex: 'type',
        key: '1',
        align: 'center',
        scopedSlots: {
          customRender: 'textCustom'
        }
      }, {
        slots: {
          title: '模版名称'
        },
        dataIndex: 'name',
        key: '2',
        align: 'center'
      }, {
        slots: {
          title: '代码'
        },
        dataIndex: 'code',
        key: '3',
        align: 'center'
      }, {
        slots: {
          title: '控件'
        },
        dataIndex: 'display',
        key: '4',
        align: 'center',
        scopedSlots: {
          customRender: 'display'
        }
      }, {
        slots: {
          title: '排序'
        },
        dataIndex: 'sort',
        key: '5',
        align: 'center'
      }, {
        slots: {
          title: '状态'
        },
        dataIndex: 'status',
        key: '6',
        align: 'center',
        scopedSlots: {
          customRender: 'status'
        }
      }, {
        slots: {
          title: '更新时间'
        },
        dataIndex: 'updateAt',
        key: '7',
        align: 'center',
        width: 200
      }, {
        slots: {
          title: '操作'
        },
        width: 150,
        key: '8',
        align: 'center',
        scopedSlots: {
          customRender: 'action'
        }
      }]
    };
  },
  computed: {
    hasSelected() {
      return this.selectedRowKeys.length > 0;
    }
  },
  created() {
    this.getTableFun();
  },
  methods: {
    seeType(val) {
      let arr = this.typeList.filter(item => item.id == val);
      return arr[0].name;
    },
    seeDisplay(val) {
      let arr = this.controlList.filter(item => item.id == val);
      return arr[0].name;
    },
    getTableFun() {
      let obj = this.form;
      obj.page = this.pagination.current;
      obj.pageSize = this.pagination.pageSize;
      templateList(obj).then(res => {
        console.log(res);
        this.data = res.items;
        this.pagination.total = res.totalNum;
      });
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
    handleAdd() {
      this.templateShow = true;
      this.$nextTick(() => {
        this.$refs.templateFrom.init({
          type2: 'add'
        });
      });
    },
    handleEdit(obj) {
      obj.type2 = 'edit';
      this.templateShow = true;
      this.$nextTick(() => {
        this.$refs.templateFrom.init(obj);
      });
    },
    getTemplateTable() {
      this.pagination.current = 1;
      this.getTableFun();
    },
    handleStandardTableChange(val) {
      this.pagination = val;
      this.getTableFun();
    },
    handleDelete(val) {
      let _this = this;
      this.$alert(this.$t('是否确认删除该模板') + '？', {
        confirmButtonText: _this.$t('确定')
      }).then(() => {
        delTemplate({
          templateIds: val.templateId
        }).then(res => {
          _this.$message.success(_this.$t('删除成功') + '!');
          _this.getTableFun();
        });
      });
    },
    checkedFun(val) {
      console.log(val);
      if (!this.isAuth('home.insuranceTemplateStatus')) {
        this.$message.error(this.$t('暂无权限'));
        return false;
      }
      templateStatus({
        templateId: val.templateId,
        status: val.status == 1 ? 0 : 1
      }).then(res => {
        this.$message.success(this.$t('修改成功') + '!');
        val.status = val.status == 1 ? 0 : 1;
      });
    },
    handleDel() {
      if (expandedRowKeys.length == 0) {
        this.$message.error(this.$t('请选择') + this.$t('要删除的数据'));
        return false;
      }
      let arr = [];
      expandedRowKeys.map(item => {
        arr.push(item.templateId);
      });
      delTemplate({
        templateIds: arr.join(',')
      }).then(res => {
        expandedRowKeys = [];
        this.$message.success(this.$t('删除成功') + '!');
        this.getTableFun();
      });
    }
  }
};